<script>
	export let projectName = "Unknown Project"
	export let logoSrc = "logo.png"
	export let firebaseConfig
	export let googleplayConsoleId
	export let ticketPlugin
	export let userDetailsPlugin
    export let experimentAvailableParams
	export let tournamentTypes

	const firebaseConsoleUrl = "https://console.firebase.google.com/u/0/project/" + firebaseConfig.projectId
	const googleplayConsoleUrl = "https://play.google.com/console/u/0/developers/" + googleplayConsoleId

	setContext("firebaseConsoleUrl", firebaseConsoleUrl)
	setContext("firebaseStorageBucket", firebaseConfig.storageBucket)
    setContext("googleplayConsoleUrl", googleplayConsoleUrl)
	setContext("ticketPlugin", ticketPlugin)
	setContext("userDetailsPlugin", userDetailsPlugin)
    setContext("experimentAvailableParams", experimentAvailableParams)
	setContext("tournamentTypes", tournamentTypes)
	
	import firebase from "firebase/app"
	import FirebaseAuth from "./FirebaseAuth.svelte"
    import { setContext } from 'svelte'

	// Your web app's Firebase configuration
	// For Firebase JS SDK v7.20.0 and later, measurementId is optional
	firebase.initializeApp(firebaseConfig);

	let firebaseUser
	let userRole
    
    $: setContext("firebaseUser", firebaseUser)
    $: setContext("userRole", userRole)

	$: firebaseUserName = (firebaseUser ? firebaseUser.displayName || firebaseUser.email || "Anonymous" : "nouser")
		+ " (" + (userRole || "norole") + ")"

	// Routing ///////////////////////////////////////////////////
	import Router from "svelte-spa-router"
	import News from "./News.svelte"
	import HelpDesk from "./HelpDesk.svelte"
	import ClosedTickets from "./ClosedTickets.svelte"
	import Ticket from "./Ticket.svelte"
	//import ManageDLC from "./ManageDLC.svelte"
	import Tournaments from "./Tournaments.svelte"
	import ClanEvents from "./ClanEvents.svelte"
	import Users from "./Users.svelte"
	import UserDetails from "./UserDetails.svelte"
	import Experiments from "./Experiments.svelte"
	import Experiment from "./Experiment.svelte"

	const routes = {
		'/HelpDesk/': HelpDesk,
		'/ClosedTickets/:startAtDateMs': ClosedTickets,
		'/Ticket/:id': Ticket,
		//'/ManageDLC/': ManageDLC,
		'/Tournaments/': Tournaments,
		'/ClanEvents/': ClanEvents,
		'/Experiments/': Experiments,
		'/Experiment/:id': Experiment,
		'/Users/': Users,
		'/User/:id': UserDetails,
		'*': News,
	}
</script>

<svelte:head>
	<title>{projectName} - Firebase Admin</title>
	<link rel="stylesheet" href="https://www.gstatic.com/firebasejs/ui/4.6.1/firebase-ui-auth.css" />
</svelte:head>


<header>
	<nav class="top-nav">
		<div class="nav-wrapper">
			<img src="{logoSrc}" alt="Logo" width=128px height=128px/>
			<a href="/" class="page-title">{projectName}</a>

			<div class="toolbar">
				{#if firebaseUser}
					<button on:click={ e => firebase.auth().signOut() } class="btn-flat waves-effect waves-teal" title="Sign out">
						<i class="material-icons">logout</i>
					</button>
					<span class="hide-on-med-and-down">Hi {firebaseUserName}!</span>
				{/if}
			</div>			
		</div>
	</nav>
</header>
	
<div class="row">
	
	<div class="col s12 m4 l2 collection" id="side-navigation">
		<a class="collection-item" href="#/HelpDesk/"><i class="material-icons left">help_center</i> Help desk</a>
		<a class="collection-item" href="#/ClosedTickets/-1"><i class="material-icons left">done_all</i> Closed tickets</a>
		<!--<a class="collection-item" href="#/ManageDLC/"><i class="material-icons left">cloud</i> Manage DLC </a>-->
		<a class="collection-item" href="#/Tournaments/"><i class="material-icons left">view_headline</i> Tournaments </a>
		<a class="collection-item" href="#/ClanEvents/"><i class="material-icons left">storage</i> ClanEvents </a>
		<a class="collection-item" href="#/Experiments/"><i class="material-icons left">call_split</i> A/B testing</a>
		<a class="collection-item" href="#/Users/"><i class="material-icons left">person_search</i> User space</a>
		<a class="collection-item" href={firebaseConsoleUrl + "/firestore/data~2FAdmins"}><i class="material-icons left">plumbing</i> Admin list</a>
	</div>

	<FirebaseAuth bind:firebaseUser bind:userRole />

	{#if firebaseUser && userRole}
		<Router {routes}/>
	{/if}

</div>

<footer class="page-footer">
	<address>Россия, Spb, Цветочная <a href="mailto:info.artogon@gmail.com">Tim Sadovsky</a></address>
	<div class="footer-copyright">
		<div class="container">
		Copyright © 2021 by Friedeggames. All rights reserved!
		<!-- <a class="grey-text text-lighten-4 right" href="https://github.com/Dogfalo/materialize/blob/master/LICENSE">MIT License</a> -->
		</div>
	</div>		
</footer>	

<style>
	.row {
		min-height: 70vh;		
	}

	.page-title {
		font-size: 48px;
	}
	header nav.top-nav {
		height: 130px; 
	}
	header .nav-wrapper {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	header .nav-wrapper > * {
		margin-left: 15px;
	}
	header .toolbar  {
		font-size: 13px;
		flex-grow: 1;
		padding-right: 25px;
		display: flex;
		flex-direction: row-reverse;
		align-items: center;
		height: 100%;
	}
	header .toolbar button {
		color: white;
	}
	header .toolbar i {
		line-height: 0;
		height: auto;
	}	

	#side-navigation {
		margin-top: 20px;
	}

	.page-footer {
		text-align: center;
	}
	.page-footer address {
		margin-bottom: 19px;
	}
</style>
